import { BaseBlockProps } from '../../defs/block';

export type OctopusBlockID = 'octopus';

export type OctopusBlockType = 'octopus';

export type OctopusBlockProps = {
  type: OctopusBlockType;
} & BaseBlockProps;

export const octopusBlockProps: Record<OctopusBlockID, OctopusBlockProps> = {
  octopus: {
    id: 'oc',
    type: 'octopus',
    immobile: true,
    generator: true,
  },
};
